import { Component, computed, input, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import { IconComponent } from 'projects/components/pay-icon/icon.component';
import { ComponentsToTextPipe } from 'projects/login/src/app/layout/login-layout/components-to-text.pipe';
import { FormatScheduledTimePipe } from 'projects/login/src/app/layout/login-layout/components/incident-entry/format-scheduled-time.pipe';
import { ServerIncidentsIncident } from 'projects/login/src/app/services/server-status/models/server-incidents-incident';
import { IconNames } from 'projects/components/pay-icon/IconNames';

@Component({
  selector: 'pay-login-incident-entry',
  imports: [IconComponent, TranslatePipe, ComponentsToTextPipe, FormatScheduledTimePipe],
  templateUrl: './incident-entry.component.html',
})
export class IncidentEntryComponent {
  private _translate = inject(TranslateService);

  readonly incident = input<ServerIncidentsIncident>();
  protected readonly IconNames = IconNames;
  protected readonly dayjs = dayjs;
  description = computed(() => {
    return this.incident()?.incident_updates.at(0)?.body ?? '';
  });
  getMonthName(month: number) {
    return this._translate.instant('general.months.short.' + month);
  }
}
